import { useTheme } from '@mui/material';
import { useMemo } from 'react';

const useAssetronHeadingStyles = () => {
  const theme = useTheme();

  const styles = useMemo(
    () => ({
      TitleContainer: {
        fontSize: theme.sizeGuide.lgxl,
        [theme.breakpoints.down('sm')]: {
          fontSize: theme.sizeGuide['3xl'],
        },
      },
    }),
    [theme],
  );

  return styles;
};

export default useAssetronHeadingStyles;
